import { Component } from 'react';

import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';

import ShipmentDetailPanel from '../ShipmentDetailPanel';
import ChatBoxContainer from '../ShipmentSupportPanel/ChatBoxContainer';
import * as E from './styles';

export default class ShipmentContainerPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 'shipmentDetails',
    };

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  render() {
    const { onChangePanel } = this.props;

    return (
      <E.Container>
        <E.BackButtonContainer>
          <E.BackButton onClick={() => onChangePanel('assignmentDetail')}>{`< Back to Assignment Details`}</E.BackButton>
        </E.BackButtonContainer>
        <E.Inner>
          <TabContext value={this.state.value}>
            <TabList onChange={this.handleChange} centered sx={{ '& .MuiTab-root': { fontSize: 12 } }}>
              <Tab label="SHIPMENT DETAILS" value="shipmentDetails" />
              <Tab label="CUSTOMER SUPPORT SHIPMENT CHAT" value="customerSupport" />
            </TabList>
            <TabPanel value="shipmentDetails">
              <ShipmentDetailPanel onRemoveShipment={this.props.onRemoveShipment} />
            </TabPanel>
            <TabPanel value="customerSupport">
              <ChatBoxContainer />
            </TabPanel>
          </TabContext>
        </E.Inner>
      </E.Container>
    );
  }
}
